<template>
  <div class="font-inter h-[1040px] bg-[#FFFFFF] rounded-t-[20px] mt-3">
    <NavbarComponent />

    <div
      class="my-6 mx-5 justify-between bg-[#FAFBFC] px-6 py-8 space-y-8 rounded-[12px]"
    >
      <h1
        v-if="activeSettingsTab !== 'investment_history'"
        class="text-[24px] font-bold mb-6"
      >
        Settings
      </h1>

      <div class="p- space-y-6">
        <TabComponent
          :tabs="getSettingsTabs()"
          v-model="activeSettingsTab"
          :compact="false"
        />

        <div v-if="activeSettingsTab === 'My Details'" class=" ">
          <div class="space-y-5">
            <div
              class="flex justify-between items-center text-grayDark text-[14px]"
            >
              <div class="space-y-2">
                <p class="text-[16px] font-bold text-primaryDarkBg">
                  Personal Info
                </p>
                <p>Update your photo and personal details here.</p>
              </div>

              <div class="flex gap-4">
                <button
                  v-if="!editMode"
                  @click="editMode = true"
                  class="py-2 px-4 bg-primaryDark text-white rounded"
                >
                  Edit
                </button>
                <button
                  v-if="editMode"
                  @click="cancelEdit"
                  class="flex border-[1px] border-grayDark hover:bg-primaryDark hover:text-primaryLight text-primaryDark text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  v-if="editMode"
                  @click="updateUserProfile"
                  class="flex bg-primaryDarkBg hover:bg-primaryDark text-white text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]"
                >
                  Save
                </button>
              </div>
            </div>
            <hr class="w-full border-t-[1px] border-[#E5E7ED]" />

            <div class="flex items-center space-x-8 text-grayDark text-[14px]">
              <p class="w-[280px]">Name</p>
              <div class="flex gap-6 mb-4">
                <div class="">
                  <input
                    type="text"
                    :disabled="!editMode"
                    v-model="user.first_name"
                    class="mt-1 block w-[244px] px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  />
                </div>
                <div class="">
                  <input
                    type="text"
                    :disabled="!editMode"
                    v-model="user.last_name"
                    class="mt-1 block w-[244px] px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  />
                </div>
              </div>
            </div>
            <hr class="w-full border-t-[1px] border-[#E5E7ED]" />

            <div class="flex items-center space-x-8 text-grayDark text-[14px]">
              <p class="w-[280px]">Email</p>
              <div class="">
                <input
                  type="email"
                  :disabled="!editMode"
                  v-model="user.email"
                  class="mt-1 block w-[512px] px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>
            </div>
            <hr class="w-full border-t-[1px] border-[#E5E7ED]" />
            <div class="flex items-center space-x-8 text-grayDark text-[14px]">
              <p class="w-[280px]">Phone</p>
              <div class="">
                <input
                  type="phone"
                  :disabled="!editMode"
                  v-model="user.phone"
                  class="mt-1 block w-[512px] px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>
            </div>
            <hr class="w-full border-t-[1px] border-[#E5E7ED]" />

            <div class="flex gap-8 items-center text-grayDark text-[14px]">
              <div class="space-y-2 w-[280px]">
                <p class="text-[16px] font-bold text-primaryDarkBg">
                  Your photo
                </p>
                <p>This will be displayed on your profile</p>
              </div>
              <div class="flex gap-4">
                <!-- Profile Picture Preview -->
                <div
                  class="flex items-center justify-center rounded-full w-[64px] h-[64px] bg-primaryDark text-primaryLight text-[14px] font-bold overflow-hidden"
                >
                  <img
                    v-if="profilePicture"
                    :src="profilePicture"
                    alt="Profile Picture"
                    class="object-cover w-full h-full"
                  />
                  <img
                    v-if="user.profile_picture"
                    :src="user.profile_picture"
                    alt="Profile Picture"
                    class="object-cover w-full h-full"
                  />
                  <!-- <span v-else>{{ user?.profile_picture }}</span> -->
                </div>

                <!-- Upload Section -->
                <div
                  v-if="editMode"
                  @click="triggerFileUpload"
                  class="w-[428px] h-[126px] border border-grayLight rounded-[16px] py-4 px-6 flex flex-col justify-between items-center bg-primaryLight space-y-2 cursor-pointer"
                >
                  <div
                    class="flex items-center justify-center rounded-full w-10 h-10 bg-[#F2F4F7]"
                  >
                    <img
                      src="@/assets/settings/upload-cloud.svg"
                      alt="upload-icon"
                      class="rounded-lg"
                    />
                  </div>
                  <span class="flex text-[14px] gap-1">
                    <p class="font-medium text-primaryDarkBg">
                      Click to upload
                    </p>
                    <p>or drag or drop</p>
                  </span>
                  <p class="text-[12px]">
                    SVG, PNG, JPG or GIF (max. 800x400px)
                  </p>
                </div>

                <!-- Hidden File Input -->
                <input
                  ref="fileInput"
                  type="file"
                  accept="image/svg+xml, image/png, image/jpeg, image/gif"
                  class="hidden"
                  @change="handleFileUpload"
                />
                <!-- <button
                    v-if="temporaryFile"
                    @click="uploadProfilePicture"
                    class="w-[10px] bg-primaryDarkBg text-white rounded mt-2"
                  >
                    Save
                  </button> -->
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <div v-if="activeSettingsTab === 'Password'" class=" ">
            <div class="space-y-4">
              <div
                class="flex justify-between items-center text-grayDark text-[14px]"
              >
                <div class="space-y-2">
                  <p class="text-[16px] font-bold text-primaryDarkBg">
                    Password
                  </p>
                  <p>
                    Please enter your current password to change your password.
                  </p>
                </div>
                <button
                  v-if="!editPasswordMode"
                  @click="editPasswordMode = true"
                  class="py-2 px-4 bg-primaryDark text-white rounded"
                >
                  Edit
                </button>

                <div v-if="editPasswordMode" class="flex gap-4">
                  <button
                    @click="cancelPasswordEdit"
                    class="flex border-[1px] border-grayDark hover:bg-primaryDark hover:text-primaryLight text-primaryDark text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]"
                  >
                    Cancel
                  </button>
                  <button
                    @click="updatePassword"
                    class="flex bg-primaryDarkBg hover:bg-primaryDark text-white text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]"
                  >
                    Save
                  </button>
                </div>
              </div>
              <hr class="w-full border-t-[1px] border-[#E5E7ED]" />

              <div v-if="editPasswordMode" class="space-y-5">
                <div
                  class="flex items-center space-x-8 text-grayDark text-[14px]"
                >
                  <p class="w-[280px]">Current password</p>
                  <div class="">
                    <input
                      type="password"
                      v-model="currentPassword"
                      class="mt-1 block w-[512px] px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    />
                  </div>
                </div>
                <hr class="w-full border-t-[1px] border-[#E5E7ED]" />
                <div
                  class="flex items-center space-x-8 text-grayDark text-[14px]"
                >
                  <p class="w-[280px]">New password</p>
                  <div class="">
                    <input
                      type="password"
                      v-model="newPassword"
                      class="mt-1 block w-[512px] px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    />
                  </div>
                </div>
                <hr class="w-full border-t-[1px] border-[#E5E7ED]" />
                <div
                  class="flex items-center space-x-8 text-grayDark text-[14px]"
                >
                  <p class="w-[280px]">Confirm password</p>
                  <div class="">
                    <input
                      type="password"
                      v-model="confirmPassword"
                      class="mt-1 block w-[512px] px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="activeSettingsTab === 'Notifications'">
            <div class="flex space-between space-x-6">
                <div class="space-y-2 py-4 bg-primaryLight font-medium w-full h-[50vh] flex items-center justify-center rounded-lg">
                    <p class="text-primaryDark text-[32px]">
                      Coming Soon!
                    </p>
                </div>
              </div>

            <!-- <div class="space-y-5">
              <div
                class="flex justify-between items-center text-grayDark text-[14px]"
              >
                <div class="space-y-2">
                  <p class="text-[16px] font-bold text-primaryDarkBg">
                    Notifications
                  </p>
                  <p>
                    Enable notifications to find out what's going on when you're
                    not online. You can disable these anytime.
                  </p>
                </div>
                <div class="flex gap-4">
                  <button
                    v-if="editMode"
                    @click="cancelEdit"
                    class="flex border-[1px] border-grayDark hover:bg-primaryDark hover:text-primaryLight text-primaryDark text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]"
                  >
                    Cancel
                  </button>
                  <button
                    v-if="editMode"
                    @click="updateUser"
                    class="flex bg-primaryDarkBg hover:bg-primaryDark text-white text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]"
                  >
                    Save
                  </button>
                </div>
              </div>
              <hr class="w-full border-t-[1px] border-[#E5E7ED]" />
              <div class="space-y-6">
                <div class="space-y-2">
                  <p class="text-[16px] font-bold text-primaryDarkBg">
                    Comments
                  </p>
                  <p class="text-[14px] text-grayDark">
                    These are notifications for comments on your posts and
                    replies to your comments.
                  </p>
                </div>
                <div class="text-[14px] space-y-4">
                  <span class="flex space-x-2">
                    <img
                      src="@/assets/settings/Checkbox.svg"
                      alt="team"
                      class="rounded-lg"
                    />
                    <p class="font-medium text-primaryDarkBg">
                      Do not notify me
                    </p>
                  </span>
                  <div class="space-y-2">
                    <span class="flex space-x-2">
                      <img
                        src="@/assets/settings/Checkbox.svg"
                        alt="team"
                        class="rounded-lg"
                      />
                      <p class="font-medium text-primaryDarkBg">
                        Mentions only
                      </p>
                    </span>
                    <p class="text-[14px] text-grayDark ml-6">
                      Only notify me if I’m mentioned in a comment.
                    </p>
                  </div>
                  <div class="space-y-2">
                    <span class="flex space-x-2">
                      <img
                        src="@/assets/settings/Input.svg"
                        alt="team"
                        class="rounded-lg"
                      />
                      <p class="font-medium text-primaryDarkBg">All comments</p>
                    </span>
                    <p class="text-[14px] text-grayDark ml-6">
                      Notify me for all comments on my posts.
                    </p>
                  </div>
                </div>
              </div>

              <div class="space-y-6">
                <div class="space-y-2">
                  <p class="text-[16px] font-bold text-primaryDarkBg">
                    Reminders
                  </p>
                  <p class="text-[14px] text-grayDark">
                    These are notifications to remind you of updates you might
                    have missed.
                  </p>
                </div>
                <div class="text-[14px] space-y-4">
                  <span class="flex space-x-2">
                    <img
                      src="@/assets/settings/Checkbox.svg"
                      alt="team"
                      class="rounded-lg"
                    />
                    <p class="font-medium text-primaryDarkBg">
                      Do not notify me
                    </p>
                  </span>
                  <div class="space-y-2">
                    <span class="flex space-x-2">
                      <img
                        src="@/assets/settings/Checkbox.svg"
                        alt="team"
                        class="rounded-lg"
                      />
                      <p class="font-medium text-primaryDarkBg">
                        Important reminders only
                      </p>
                    </span>
                    <p class="text-[14px] text-grayDark ml-6">
                      Only notify me if the reminder is tagged as important.
                    </p>
                  </div>
                  <div class="space-y-2">
                    <span class="flex space-x-2">
                      <img
                        src="@/assets/settings/Input.svg"
                        alt="team"
                        class="rounded-lg"
                      />
                      <p class="font-medium text-primaryDarkBg">
                        All reminders
                      </p>
                    </span>
                    <p class="text-[14px] text-grayDark ml-6">
                      Notify me for all reminders.
                    </p>
                  </div>
                </div>
              </div>
            </div> -->
          </div>

          <div v-else-if="activeSettingsTab === 'Device Settings'">
            <div class="flex space-between space-x-6">
                <div class="space-y-2 py-4 bg-primaryLight font-medium w-full h-[50vh] flex items-center justify-center rounded-lg">
                    <p class="text-primaryDark text-[32px]">
                      Coming Soon!
                    </p>
                </div>
              </div>
            <!-- <div class="space-y-5">
              <hr class="w-full border-t-[1px] border-[#E5E7ED]" />
              <TabComponent
                :tabs="deviceSettingsTabs"
                v-model="activeDeviceSettingsTab"
                :compact="false"
              />
              <div
                class="space-y-6"
                v-if="activeDeviceSettingsTab === 'Active History'"
              >
                <div
                  class="flex justify-between items-center text-grayDark text-[14px]"
                >
                  <div class="space-y-2">
                    <p>
                      Active History shows the devices connected to your account
                      and the last active time.
                    </p>
                  </div>
                </div>
                <hr class="w-full border-t-[1px] border-[#E5E7ED]" />
                <div class="space-y-6">
                  <div class="flex justify-between items-center text-[14px]">
                    <div class="flex gap-2 items-center">
                      <div
                        class="flex justify-center items-center space-y-2 bg-[#E6FBE8] w-[64px] h-[64px] rounded-full"
                      >
                        <img
                          src="@/assets/settings/Vector.svg"
                          alt="desktop"
                          class="rounded-lg"
                        />
                      </div>
                      <span class="space-y-1">
                        <p class="font-medium text-[14px] text-primaryDarkBg">
                          Mac OS X Big Sur
                        </p>
                        <p class="text-[11px] text-grayDark">
                          Last Activity | Active
                        </p>
                      </span>
                    </div>
                    <p class="font-semibold text-[11px] text-grayDark">
                      Configure Device
                    </p>
                  </div>
                  <div class="flex justify-between items-center text-[14px]">
                    <div class="flex gap-2 items-center">
                      <div
                        class="flex justify-center items-center space-y-2 bg-[#E6FBE8] w-[64px] h-[64px] rounded-full"
                      >
                        <img
                          src="@/assets/settings/phone_iphone.svg"
                          alt="desktop"
                          class="rounded-lg"
                        />
                      </div>
                      <span class="space-y-1">
                        <p class="font-medium text-[14px] text-primaryDarkBg">
                          IOS 14 Iphone X
                        </p>
                        <p class="text-[11px] text-grayDark">
                          Last Activity | Active
                        </p>
                      </span>
                    </div>
                    <p class="font-semibold text-[11px] text-grayDark">
                      Configure Device
                    </p>
                  </div>
                  <div class="flex justify-between items-center text-[14px]">
                    <div class="flex gap-2 items-center">
                      <div
                        class="flex justify-center items-center space-y-2 bg-[#E6FBE8] w-[64px] h-[64px] rounded-full"
                      >
                        <img
                          src="@/assets/settings/Vector.svg"
                          alt="desktop"
                          class="rounded-lg"
                        />
                      </div>
                      <span class="space-y-1">
                        <p class="font-medium text-[14px] text-primaryDarkBg">
                          Windows 10 Dell
                        </p>
                        <span class="flex gap-1">
                          <p class="text-[11px] text-grayDark">
                            Last Activity |
                          </p>
                          <p class="text-[11px] text-grayDark">2 days ago</p>
                        </span>
                      </span>
                    </div>
                    <p class="font-semibold text-[11px] text-grayDark">
                      Configure Device
                    </p>
                  </div>
                </div>
                <p class="mt-32 text-[15px] font-medium text-grayDark">
                  Total Active Device Connected | 4
                </p>
              </div>

              <div
                class="space-y-6"
                v-if="activeDeviceSettingsTab === 'Devices & Configurations'"
              >
                <div
                  class="flex justify-between items-center text-grayDark text-[14px]"
                >
                  <div class="space-y-2">
                    <p>Device & Configurations settings.</p>
                  </div>
                </div>
                <hr class="w-full border-t-[1px] border-[#E5E7ED]" />
                <div
                  class="border border-[#F1F2F4] rounded-[12px] px-4 py-4 space-y-6"
                >
                  <div class="flex justify-between items-center text-[14px]">
                    <div class="flex gap-2 items-center">
                      <span class="flex space-x-1">
                        <img
                          src="@/assets/settings/Vector.svg"
                          alt="desktop"
                          class="w-[18px] h-[18px] rounded-lg"
                        />
                        <p class="font-medium text-[14px] text-primaryDarkBg">
                          Mac OS X Big Sur
                        </p>
                      </span>
                    </div>
                    <p class="font-semibold text-[11px] text-grayDark">
                      Configure Device
                    </p>
                  </div>
                  <div class="flex flex-wrap items-center gap-2 mt-4">
                    <span
                      v-for="(social, index) in socials"
                      :key="index"
                      class="flex items-center px-2 py-1 bg-[#F1F2F4] text-grayDark text-[13px] border border-grayLight rounded-full cursor-pointer"
                    >
                      {{ social }}
                      <button @click.prevent="removeSocial(index)" class="ml-2">
                        <img
                          src="@/assets/dashboard/iconoir_cancel.svg"
                          alt="Close"
                          class="w-4 h-4"
                        />
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <div
            v-else-if="isInvestor && activeSettingsTab === 'investment_history'"
          >
            <div class="space-y-5">
              <div
                class="flex justify-between items-center text-grayDark text-[14px]"
              >
                <div class="space-y-2">
                  <p class="text-[24px] font-bold text-primaryDarkBg">
                    Investment History
                  </p>
                  <p>
                    See all your investment references from Past to Present.
                  </p>
                </div>
                <div class="flex gap-4">
                  <button
                    v-if="editMode"
                    @click="cancelEdit"
                    class="flex border-[1px] border-grayDark hover:bg-primaryDark hover:text-primaryLight text-primaryDark text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]"
                  >
                    Cancel
                  </button>
                  <button
                    v-if="editMode"
                    @click="updateUser"
                    class="flex bg-primaryDarkBg hover:bg-primaryDark text-white text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]"
                  >
                    Save
                  </button>
                </div>
              </div>

              <div class="overflow-x-auto text-grayDark">
                <div
                  v-if="invested_projects.length === 0"
                  class="text-center py-16 text-gray-500"
                >
                  No history yet.
                </div>
                <div v-else>
                  <table class="min-w-full divide-y">
                    <thead class="text-[12px] text-primaryDarkBg">
                      <tr>
                        <th
                          scope="col"
                          class="px-6 py-3 text-left tracking-wider"
                        >
                          Project Name
                        </th>
                        <th
                          scope="col"
                          class="px-6 py-3 text-left tracking-wider"
                        >
                          Amount Invested
                        </th>
                        <th
                          scope="col"
                          class="px-6 py-3 text-left tracking-wider"
                        >
                          Payment Status
                        </th>
                        <th
                          scope="col"
                          class="px-6 py-3 text-left tracking-wider"
                        >
                          Reference
                        </th>
                        <th
                          scope="col"
                          class="px-6 py-3 text-left tracking-wider"
                        >
                          Date
                        </th>
                      </tr>
                    </thead>
                    <tbody class="bg-white divide-y text-bodyText">
                      <tr
                        v-for="project in projects"
                        :key="project.project_id"
                        @click="goToProject(project.project_id)"
                        class="mb-2 cursor-pointer text-[13px]"
                      >
                        <td class="px-4 py-4 font-semibold whitespace-nowrap">
                          {{ project.project_name }}
                        </td>
                        <td class="px-4 py-4 whitespace-nowrap">
                          <div v-if="isAdmin" class="flex items-center">
                            <div
                              class="relative w-[124px] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden"
                            >
                              <div
                                class="absolute top-0 left-0 h-full bg-primaryDark rounded-full"
                                :style="{ width: `${project.progress}%` }"
                              ></div>
                            </div>
                            <span class="ml-2 text-[12px] font-medium"
                              >{{ project.progress }}%</span
                            >
                          </div>
                          <div v-else class="flex items-center">
                            <div
                              class="relative w-[124px] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden"
                            >
                              <!-- Inner progress bar -->
                              <div
                                class="absolute top-0 left-0 h-full bg-primaryDark rounded-full"
                                :style="{
                                  width: `${project.project_progress}%`,
                                }"
                              ></div>
                            </div>
                            <span class="ml-2 text-[12px] font-medium"
                              >{{ project.project_progress }}%</span
                            >
                          </div>
                        </td>
                        <td class="px-4 py-4 whitespace-nowrap">
                          <div
                            v-if="project.project_status === 'Active'"
                            class="flex items-center gap-2 py-1 px-2 rounded-full bg-[#EBF1FF] text-primaryDarkBg"
                          >
                            <div
                              class="w-2 h-2 bg-primaryDarkBg rounded-full"
                            ></div>
                            {{ project.project_status }}
                          </div>
                          <div
                            v-else-if="project.project_status === 'Not Started'"
                            class="flex items-center gap-2 py-1 px-2 rounded-full bg-[#FFF5E6] text-pendingStatus"
                          >
                            <div
                              class="w-2 h-2 bg-pendingStatus rounded-full"
                            ></div>
                            {{ project.project_status }}
                          </div>
                          <div
                            v-else-if="project.project_status === 'Completed'"
                            class="flex items-center gap-2 py-1 px-2 rounded-full bg-[#EBFFEB] text-completedStatus"
                          >
                            <div
                              class="w-2 h-2 bg-completedStatus rounded-full"
                            ></div>
                            {{ project.project_status }}
                          </div>
                          <div
                            v-else
                            class="flex items-center gap-2 py-1 px-2 rounded-full bg-[#EBF1FF] text-primaryDarkBg"
                          >
                            <div
                              class="w-2 h-2 bg-primaryDarkBg rounded-full"
                            ></div>
                            {{ project.status }}
                          </div>
                        </td>

                        <td class="px-4 py-4 whitespace-nowrap">
                          <div
                            v-if="isAdmin"
                            class="flex items-center rounded-[8px] text-grayDark font-medium gap-2"
                          >
                            <img
                              src="@/assets/projects/task-square.svg"
                              alt="team"
                              class="h-4 overlap"
                            />
                            {{ formatDate(project.end_date) }}
                          </div>
                          <div
                            v-else
                            class="flex items-center rounded-[8px] text-grayDark font-medium gap-2"
                          >
                            <img
                              src="@/assets/projects/task-square.svg"
                              alt="team"
                              class="h-4 overlap"
                            />
                            {{ formatDate(project.project_end_date) }}
                          </div>
                        </td>

                        <td class="px-4 py-4 whitespace-nowrap">
                          <div class="flex items-center gap-2">
                            <span
                              >{{ project.completedTasks || 0 }} /
                              {{ project.totalTasks || 0 }}</span
                            >
                          </div>
                        </td>
                        <td class="px-4 py-4 whitespace-nowrap">
                          <button
                            @click="goToProjectAssets(project.project_id)"
                            class="transition flex items-center gap-4 underline"
                          >
                            View details
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <PaginationComponent
                    :currentPage="currentPage"
                    :totalPages="totalPages"
                    @changePage="handlePageChange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";
import NavbarComponent from "../NavbarComponent.vue";
import TabComponent from "../profiles/TabComponent.vue";
import { createTabStateManager } from "@/utils/tabStateManager";

export default {
  name: "SettingsComponent",
  components: {
    NavbarComponent,
    TabComponent,
  },
  data() {
    return {
      socials: ["Whatsapp", "Twitter", "Facebook", "LinkedIn", "Instagram"],
      invested_projects: [],
      profilePicture: null, // Holds the temporary picture URL for preview
      originalProfilePicture: null, // Store the DB profile picture
      temporaryFile: null, // To hold the raw file data for upload
      talentId: null,
      userId: null,
      editMode: false,
      editPasswordMode: false,
      user: {
        user_id: "",
        first_name: "",
        last_name: "",
        email: "",
        role: "",
        phone: "",
      },
      editUser: {},
      loading: true,
      activeSettingsTab: "",

      activeDeviceSettingsTab:
        localStorage.getItem("activeDeviceSettingsTab") || "Active History",

      deviceSettingsTabs: ["Active History", "Devices & Configurations"],

      tabStateManager: null,
      mainTabStateManager: null,
      deviceTabStateManager: null,

      // Storage listeners
      mainTabStorageListener: null,
      deviceTabStorageListener: null,

      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
    isInvestor() {
      return this.$store.getters.isInvestor;
    },
    isUser() {
      return this.$store.getters.isTalent;
    },
    fullName() {
      if (
        !this.talent ||
        (!this.talent.talent_first_name && !this.talent.talent_last_name)
      ) {
        return "";
      }
      return `${this.talent.talent_first_name || ""} ${
        this.talent.talent_last_name || ""
      }`.trim();
    },
    userIdentifier() {
      return this.user?.user_id || this.$store.state.user?.user_id || "default";
    },
  },
  watch: {
    // '$route.query.section': {
    //   immediate: true,
    //   handler(newSection) {
    //     const validTabs = ['My Details', 'password', 'Notifications', 'Device Settings', 'Investment History'];
    //     if (validTabs.includes(newSection)) {
    //       this.activeSettingsTab = newSection;
    //     } else {
    //       this.activeSettingsTab = 'My Details'; // Default to 'my_details'
    //     }
    //     localStorage.setItem('activeSettingsTab', newSection);

    //   },
    // },

    // Watch main settings tab changes
    activeSettingsTab: {
      handler(newTab) {
        if (this.mainTabStateManager && newTab) {
          this.mainTabStateManager.setActiveTab(newTab);
          console.log("Main settings tab changed to:", newTab);
        }
      },
      immediate: false,
    },

    // Watch device settings sub-tab changes
    activeDeviceSettingsTab: {
      handler(newTab) {
        if (this.deviceTabStateManager && newTab) {
          this.deviceTabStateManager.setActiveTab(newTab);
          console.log("Device settings tab changed to:", newTab);
        }
      },
      immediate: false,
    },

    // Reinitialize when user changes
    "$store.state.user": {
      handler(newUser, oldUser) {
        if (newUser && newUser !== oldUser) {
          this.initTabStates();
        }
      },
      deep: true,
    },
  },
  methods: {
    removeSocial(index) {
      this.socials.splice(index, 1);
    },
    setActiveTab(tab) {
      console.log("Setting active tab to:", tab); // Debug log
      this.activeSettingsTab = tab;
    },

    // Initialize both tab state managers
    initTabStates() {
      this.initMainTabState();
      this.initDeviceTabState();
    },

    // Initialize main settings tab state
    initMainTabState() {
      // Clean up previous listener
      if (this.mainTabStorageListener) {
        window.removeEventListener("storage", this.mainTabStorageListener);
      }

      // Create user-specific storage key for main settings tabs
      const userSpecificKey = `settingsComponent_mainTab_${this.userIdentifier}`;

      // Create tab state manager
      this.mainTabStateManager = createTabStateManager(
        userSpecificKey,
        this.isInvestor ? "My Details" : "My Details", // Default tab based on user type
        this.getAvailableMainTabs() // Get tabs based on user role
      );

      // Load saved tab
      const savedTab = this.mainTabStateManager.getActiveTab();
      console.log("Loaded main tab from localStorage:", savedTab);

      // Set the tab, but also check URL query parameter
      const urlTab = this.$route.query.section;
      if (urlTab && this.getAvailableMainTabs().includes(urlTab)) {
        this.activeSettingsTab = urlTab;
        this.mainTabStateManager.setActiveTab(urlTab);
      } else {
        this.activeSettingsTab = savedTab;
      }

      // Listen for changes from other browser tabs/windows
      this.mainTabStorageListener = (e) => {
        if (e.key === userSpecificKey && e.newValue) {
          console.log("Main tab changed in another window:", e.newValue);
          this.activeSettingsTab = e.newValue;
        }
      };

      window.addEventListener("storage", this.mainTabStorageListener);
    },

    // Initialize device settings sub-tab state
    initDeviceTabState() {
      // Clean up previous listener
      if (this.deviceTabStorageListener) {
        window.removeEventListener("storage", this.deviceTabStorageListener);
      }

      // Create user-specific storage key for device settings tabs
      const userSpecificKey = `settingsComponent_deviceTab_${this.userIdentifier}`;

      // Create tab state manager
      this.deviceTabStateManager = createTabStateManager(
        userSpecificKey,
        "Active History", // Default device tab
        this.deviceSettingsTabs
      );

      // Load saved tab
      const savedTab = this.deviceTabStateManager.getActiveTab();
      console.log("Loaded device tab from localStorage:", savedTab);
      this.activeDeviceSettingsTab = savedTab;

      // Listen for changes from other browser tabs/windows
      this.deviceTabStorageListener = (e) => {
        if (e.key === userSpecificKey && e.newValue) {
          console.log("Device tab changed in another window:", e.newValue);
          this.activeDeviceSettingsTab = e.newValue;
        }
      };

      window.addEventListener("storage", this.deviceTabStorageListener);
    },

    // Get available main tabs based on user role
    getAvailableMainTabs() {
      let tabs = ["My Details", "Password", "Notifications", "Device Settings"];

      // Add investment history tab for investors
      if (this.isInvestor) {
        tabs.push("investment_history");
      }

      return tabs;
    },

    // Update the settingsTabs computed property or data
    getSettingsTabs() {
      return this.getAvailableMainTabs();
    },

    // Method to manually set active main tab (useful for programmatic changes)
    setActiveMainTab(tab) {
      console.log("Setting active main tab to:", tab);
      this.activeSettingsTab = tab;
      if (this.mainTabStateManager) {
        this.mainTabStateManager.setActiveTab(tab);
      }
    },

    // Method to manually set active device tab
    setActiveDeviceTab(tab) {
      console.log("Setting active device tab to:", tab);
      this.activeDeviceSettingsTab = tab;
      if (this.deviceTabStateManager) {
        this.deviceTabStateManager.setActiveTab(tab);
      }
    },
    updateRouteQuery(tab) {
      this.$router
        .push({
          name: "Settings",
          query: { section: tab },
        })
        .catch(() => {}); // Catch navigation duplicated error
    },

    // Clean up old localStorage entries
    cleanupOldTabPreferences() {
      // Remove old non-user-specific keys
      const oldKeys = [
        "activeSettingsTab",
        "activeDeviceSettingsTab",
        "activeRequestTab",
      ];

      oldKeys.forEach((key) => {
        if (localStorage.getItem(key)) {
          localStorage.removeItem(key);
        }
      });

      // Clean up any orphaned user-specific keys (optional)
      const keysToCleanup = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (
          key &&
          key.startsWith("settingsComponent_") &&
          !key.includes(`_${this.userIdentifier}`)
        ) {
          keysToCleanup.push(key);
        }
      }
      keysToCleanup.forEach((key) => localStorage.removeItem(key));
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.profilePicture = URL.createObjectURL(file);
        console.log("Selected file:", file);
        this.temporaryFile = file;
      }
    },

    async uploadProfilePicture() {
      if (!this.temporaryFile) {
        console.error("No file selected.");
        return;
      }
      console.log(`Uploading profile picture for user ID: ${this.userId}`);
      const formData = new FormData();
      formData.append("file", this.temporaryFile);

      try {
        const response = await apiClient.post(
          `/web/upload_profile_picture/${this.userId}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        console.log("Upload successful:", response.data);
        this.temporaryFile = false; // Reset the file
        this.fetchProfilePicture();
      } catch (error) {
        console.error("Error uploading picture:", error);
      }
    },
    async fetchProfilePicture() {
      try {
        const response = await apiClient.post("/current_user/");
        if (response.data.user.profile_picture) {
          this.profilePicture = response.data.user.profile_picture;
        }
      } catch (error) {
        console.error("Error fetching profile picture:", error);
      }
    },
    async updateUserProfile() {
      try {
        const userId = this.userId;
        await apiClient.put(`/web/users/${userId}`, {
          first_name: this.user.first_name,
          last_name: this.user.last_name,
          email: this.user.email,
          phone: this.user.phone || "",
          role: this.user.role,
        });
        this.editMode = false; // Exit edit mode
        // this.closeSideMenu()

        this.$toast.success("User updated successfully");
      } catch (error) {
        console.error("Error updating user:", error);
      }
    },

    capitalize(text) {
      if (!text) return "";
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },

    async fetchUserData() {
      try {
        const response = await apiClient.post("/current_user");
        this.user = response.data.user;
        this.userId = response.data.user.user_id;
        this.editUser = { ...this.user }; // Clone user data for editing
        console.log("fetched user data:", this.user);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },
    async updateUser() {
      try {
        if (this.isAdmin) {
          const userId = this.$route.params.userId;
          const response = await apiClient.put(
            `/web/users/${userId}`,
            this.editUser
          );
          this.user = response.data.data;
          this.editMode = false;
          this.editPasswordMode = false;

          console.log("User updated:", response.data.data);
        }
      } catch (error) {
        console.error("Error updating user:", error);
      }
    },
    cancelEdit() {
      this.editUser = { ...this.user }; // Revert changes
      this.editMode = false;
    },
    cancelPasswordEdit() {
      this.editUser = { ...this.user }; // Revert changes
      this.editPasswordMode = false;
    },
    async fetchInvestedProjects() {
      try {
        if (this.isInvestor) {
          const response = await apiClient.get(`/web/investor/me`);

          const investorData = response.data.data;
          this.invested_projects = investorData.projects || [];
          const meta = response.data.meta;
          this.currentPage = meta.current_page;
          this.totalPages = meta.total_pages;
          this.loading = false;
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        this.loading = false;
      }
    },
    async updatePassword() {
      try {
        if (
          !this.currentPassword ||
          !this.newPassword ||
          !this.confirmPassword
        ) {
          alert("All fields are required.");
          return;
        }

        if (this.newPassword !== this.confirmPassword) {
          alert("New password and confirm password do not match.");
          return;
        }

        const payload = {
          current_password: this.currentPassword,
          new_password: this.newPassword,
        };

        const response = await apiClient.put("/web/change_password", payload);

        if (response.status === 200) {
          alert("Password changed successfully.");
          this.editPasswordMode = false;
          this.currentPassword = "";
          this.newPassword = "";
          this.confirmPassword = "";
        } else {
          alert(response.data.message || "Failed to change password.");
        }
      } catch (error) {
        console.error(
          "Error updating password:",
          error.response?.data || error
        );
        alert("An error occurred while changing the password.");
      }
    },
  },
  created() {
    this.$nextTick(() => {
      this.initTabStates();
    });

    this.cleanupOldTabPreferences();

    const section = this.$route.query.section;
    if (section && this.getAvailableMainTabs().includes(section)) {
      this.setActiveMainTab(section);
    }

    this.fetchUserData();
  },

  beforeUnmount() {
    // Clean up both storage listeners
    if (this.mainTabStorageListener) {
      window.removeEventListener("storage", this.mainTabStorageListener);
    }
    if (this.deviceTabStorageListener) {
      window.removeEventListener("storage", this.deviceTabStorageListener);
    }
  },
};
</script>

<style scoped>
/* Add your styles here */
</style>
